import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

export type AuditActorType = "User" | "Nurse" | "Client" | "System";

export type AuditLogFilters = {
  targetId?: string | null; // Client/patient id
  actorType?: AuditActorType | null;
  actorId?: string | null;
  systemOnly?: boolean;
  from?: string | null; // ISO date
  to?: string | null; // ISO date
};

@Injectable({
  providedIn: "root",
})
export class AuditLogService {
  constructor(private http: HttpClient) {}

  getPagedAuditLogs(payload: {
    pageIndex: number;
    pageSize: number;
    sortOrder?: number;
    filters?: AuditLogFilters;
  }) {
    return this.http.post(`${environment.apiUrl}/audit-logs/get-paged`, payload);
  }

  clearOldLogs(olderThanIso: string) {
    return this.http.post(`${environment.apiUrl}/audit-logs/clear-old`, {
      olderThanIso,
    });
  }
}

